import { Button } from 'components/Button'
import { useModals } from 'almanac-ui/Modal'
import { LocationModal } from 'components/Wizards/RetryWizard/LocationModal'
import { useFormikContext } from 'formik'
import { useGenerateContent } from 'components/Wizards/Wizard/useGenerateContent'
import { useRootStore } from 'stores/RootStore'
import { FormSchema } from 'components/Wizards/Wizard/Form/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { AlmanacFile } from 'types'

interface Props {
  schema: FormSchema<GenerationType | ChannelType>
  project: AlmanacFile
}

export const GenerateNewDocButton = ({ schema, project }: Props) => {
  const handbooksStore = useRootStore().handbooks
  const { openModal, closeModal } = useModals()
  const { values } = useFormikContext()

  const { promptLibrary, type } = schema.describe().meta
  const { generateContent } = useGenerateContent({
    generationType: type,
    promptLibrary,
  })

  const handlePress = () => {
    openModal(
      LocationModal,
      {
        onConfirm: async (location) => {
          await generateContent({ ...(values as any), ...location })
          handbooksStore.refresh((values as any).project?.handbook?.key)
        },
        onCancel: closeModal,
        project,
      },
      { newStack: true },
    )
  }

  return (
    <Button size="lg" variant="tertiary" onPress={handlePress}>
      Generate New Doc
    </Button>
  )
}
